
import { defineComponent } from "vue";

export default defineComponent({
  props: ["images"],
  setup() {
    return {};
  }
});
